import React from "react";
import { Instagram, LinkedIn } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";

// Contact image — user will place dtg_contact.png
let ContactImage;
try {
  ContactImage = require("../images/dtg_contact.png");
} catch (e) {
  ContactImage = null;
}

const ContactSection = () => {
  const socials = [
    {
      href: "https://www.instagram.com/dointogethergames/",
      icon: <Instagram />,
      label: "Instagram",
    },
    {
      href: "https://x.com/dointogether",
      icon: <XIcon />,
      label: "X",
    },
    {
      href: "https://www.linkedin.com/company/dointogethergames/",
      icon: <LinkedIn />,
      label: "LinkedIn",
    },
  ];

  return (
    <section id="contact" className="section">
      <h2 className="section__title">Contact Us</h2>

      <div className="contact__content">
        {ContactImage && (
          <img
            src={ContactImage}
            alt="Doin' Together Games Team"
            className="contact__image"
          />
        )}

        <div className="contact__info">
          <h3 className="contact__studio-name">Doin' Together Games</h3>
          <p className="contact__email">dointogethergames@gmail.com</p>

          <div className="contact__socials">
            {socials.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="contact__social-btn"
                aria-label={social.label}
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
